import { Box, Drawer, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";

import { drawerWidth } from "config";
import useAnyModalOpen from "../ts/useAnyModalOpen";
import useFunctions from "../ts/useFunctions";
import DrawerContent from "./drawer-content";
import DrawerHeader from "./drawer-header";

interface MainDrawerProps {
  window?: any;
}

export default function MainDrawer(props: MainDrawerProps) {
  const { window } = props;
  const theme = useTheme();
  const { open, setOpen } = useFunctions();
  const isTemporary = useMediaQuery(theme.breakpoints.down("lg"));
  const isAnyModalOpen = useAnyModalOpen();

  const container =
    window !== undefined ? () => window().document.body : undefined;

  const handleDrawerClose = () => setOpen(false);

  const paperSx = {
    backgroundImage: "none",
    overflowX: "hidden",
    boxSizing: "border-box",
    transitionProperty: "all",
    transitionDuration: "225ms",
    transitionTimingFunction: "cubic-bezier(0.4,0,0.6,1)",
    borderRight: "none !important",
    ...(isTemporary
      ? {
          width: drawerWidth,
          top: 0,
          height: "100%",
        }
      : {
          width: { lg: open ? drawerWidth : 85 },
        }),
  };

  return (
    <Box
      component="nav"
      sx={{
        display: { xs: isTemporary && isAnyModalOpen ? "none" : "block", lg: "block" },
        flexShrink: { md: 0 },
        zIndex: { xs: 1402, lg: 1300 },
      }}
      aria-label="mailbox folders"
    >
      <Drawer
        container={container}
        variant={isTemporary ? "temporary" : "permanent"}
        open={open}
        onClose={isTemporary ? handleDrawerClose : undefined}
        ModalProps={{ keepMounted: true }}
        sx={{
          ...(isTemporary
            ? {}
            : {
                width: { lg: open ? drawerWidth : 85 },
                flexShrink: 0,
                whiteSpace: "nowrap",
              }),
          boxSizing: "border-box",
          "& .MuiDrawer-paper": paperSx,
        }}
      >
        <DrawerHeader isTemporary={isTemporary} onClose={handleDrawerClose} />
        <DrawerContent />
      </Drawer>
    </Box>
  );
}
